import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'react-bootstrap';

const statusToText = (status) => {
  return status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
};

export const statusToClass = (status) => {
  if (status.includes('Expired')) return 'inactive';

  return status.toLowerCase().replace(/_/g, '-').replace(/ /g, '-');
};

const updateListingStatus = (status) => {
  switch (status) {
  case 'on_market':
    return 'active';
  case 'off_market':
    return 'inactive';
  default:
    return status;
  }
};

class Pill extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    status: PropTypes.string.isRequired
  };

  render() {
    const status = updateListingStatus(this.props.status);
    const labelClass = `label-${statusToClass(status)}`;
    const labelText = statusToText(status);
    const className = `label pill-label text-uppercase ${labelClass} ${this.props.className}`;

    return <Label className={className}>{labelText}</Label>;
  }
}

class LabelWithDot extends React.Component {
  static propTypes = {
    status: PropTypes.string.isRequired
  };

  render() {
    const status = updateListingStatus(this.props.status);
    const labelClass = `label-text-${statusToClass(status)}`;

    return (
      <div className="d-inline-block">
        <span className={`dot mr-2 label-${statusToClass(status)}`} />
        <span className={labelClass} name="label">
          {statusToText(status)}
        </span>
      </div>
    );
  }
}

class LabelAsSpan extends React.Component {
  static propTypes = {
    status: PropTypes.string.isRequired,
  };

  render() {
    const status = updateListingStatus(this.props.status);
    const labelClass = `label-text-${statusToClass(status)}`;

    return (
      <span className={labelClass} name="label-as-span">
        {statusToText(status)}
      </span>
    );
  }
}

const Status = {
  Pill,
  LabelAsSpan,
  LabelWithDot
};

export default Status;
